const BLOOMERANG_INTEGRATION_NOT_FOUND_ERROR = 'Bloomerang Integration not found.';
const THANKVIEW_INTEGRATION_NOT_FOUND_ERROR = 'ThankView Integration not found.';

export { BLOOMERANG_INTEGRATION_NOT_FOUND_ERROR, THANKVIEW_INTEGRATION_NOT_FOUND_ERROR };
